<template>
    <div class="row">
        <div class="main-content col-12 col-md-12 col-lg-12">
            <div class="top-logo-hh">
                <router-link to="/" class="logo">
                    <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                </router-link>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-md-pull-6 order-md-12">
            <div class="account-box">

                <div class="account-box-title">اگر قبلا ثبت نام کردید نیازی به ثبت نام مجدد نیست.وارد شوید</div>

                <div class="account-box-content">


                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-12">
                            <div class="account-benefits">
                                <h3 class="faq-title icon-plus">
                                    مزایای عضویت در ایران مارت
                                </h3>
                                <ul class="faq-text">
                                    <li>ایجاد پنل کاربری برای مشاهده سفارشات و محصولات</li>
                                    <li>ذخیره سازی اطلاعات سفارشات شما</li>
                                    <li>سرعت بخشی به فرایند خرید</li>
                                    <li>اطلاع از قیمت فروش محصولات</li>
                                    <li>خرید بی دغدغه و آسان و امکان عودت کالا</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-12">
                            <div class="form-account-row form-account-submit">
                                <div class="parent-btn">
                                    <router-link to="/login" class="dk-btn dk-btn-info">
                                        ورود به ایران مارت
                                        <i class="fa fa-sign-in"></i>
                                    </router-link>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
        <div class="main-content col-12 col-md-6 col-lg-6 order-md-1">
            <div class="account-box">

                <div class="account-box-title">ثبت‌نام</div>
                <!--<div class="message-light">
                    اگر قبلا با ایمیل ثبت‌نام کرده‌اید، نیاز به
                    ثبت‌نام مجدد با شماره
                    همراه ندارید
                </div>-->
                <div class="account-box-content">
                    <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                        <img style="position:absolute;top:40%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
                    </div>
                    <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                        <li v-for="error in errors.all()">{{ error }}</li>
                    </ul>
                    <form @submit.prevent="validateForm" class="form-account">
                        <div class="row">

                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-account-title">نام</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons users_single-02"></i>
                                    </label>
                                    <input class="input-field" name="firstname" type="text" v-model="register.FirstName" v-validate="{required: true , max:50}" data-vv-as="نام"
                                           placeholder="نام خود را وارد نمایید">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-account-title">نام خانوادگی</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons users_single-02"></i>
                                    </label>
                                    <input class="input-field" type="text" name="lastname" v-model="register.LastName" v-validate="{required: true , max:200}" data-vv-as="نام خانوادگی"
                                           placeholder="نام خانوادگی خود را وارد نمایید">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-account-title">تلفن همراه</div>
                                <div class="form-account-row">
                                    <label class="input-label"><i class="now-ui-icons tech_mobile"></i></label>
                                    <input name="username" class="input-field" type="text" v-model="register.UserName" v-validate="{required: true,regex: /^09\d{9}$/}" data-vv-as="شماره موبایل"
                                           placeholder=" شماره موبایل خود را وارد نمایید">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-account-title">کلمه عبور</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input class="input-field" name="password" type="password" v-model="register.Password" v-validate="{required: true , min : 4 , max: 12}" ref="password" data-vv-as="رمز عبور"
                                           placeholder="کلمه عبور خود را وارد نمایید">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="form-account-title">تکرار کلمه عبور</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input class="input-field" name="repassword" type="password" v-model="register.RePassword" v-validate="{required: true,confirmed: 'password' , min : 4 , max: 12}" data-vv-as="تکرار رمز عبور"
                                           placeholder="کلمه عبور خود را مجدداً وارد نمایید">
                                </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-12">
                                <div class="form-account-agree">
                                    <label class="checkbox-form checkbox-primary">
                                        <input type="checkbox" v-model="checked">
                                        <span class="checkbox-check"></span>
                                    </label>
                                    <label for="agree">
                                        <a href="#" class="btn-link-border">حریم خصوصی</a> و <a href="#"
                                                                                                class="btn-link-border">شرایط و قوانین</a> استفاده از سرویس های سایت
                                        را مطالعه نموده و با کلیه موارد آن موافقم.
                                    </label>
                                </div>
                            </div>
                            <div class="flex w-100 margin-t-25">
                                <div class="form-account-row form-account-submit">
                                    <div class="parent-btn">
                                        <button :class="{'disadledbtn' :!checked ,'dk-btn dk-btn-info':true}" :disabled="!checked">
                                            ثبت نام
                                            <i class="now-ui-icons users_circle-08"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="account-box-footer">
                    <span>قبلا ثبت‌نام کرده‌اید؟</span>
                    <router-link to="/login" tag="a" class="btn-link-border">
                        وارد شوید
                    </router-link>
                    <div>
                        <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                register: {},
                checked: true,
                isShowSppiner: false
            }
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/UserRegister/Register', 'post', JSON.stringify(this.register),
                            response => {
                                this.isShowSppiner = false;
                                this.$emit('redirectToConfirm', response.data.Value);
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
        },
        beforeMount: function () {
            createPageTitle('ثبت نام ');
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },

    }
</script>

<style scoped>
    .top-logo-hh {
        background: #fff;
        width: auto;
        margin: 70px auto;
    }

        .top-logo-hh .logo img {
            height: 38px;
        }

        .top-logo-hh .logo {
            width: 156px;
            height: 60px;
            position: absolute;
            left: 50%;
            bottom: -20%;
            transform: translate(-50%);
            text-align: center;
            line-height: 60px;
        }

    .account-box {
        width: auto;
    }

    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }

    .account-benefits ul li::before {
        content: '\f00c';
        font-family: FontAwesome;
        margin: 0 -10px 0 5px;
        width: 1.2em;
        color: #333;
        font-size: 150%;
        vertical-align: middle;
    }

    .account-benefits ul li {
        color: #747474;
    }

    .icon-plus::before {
        font-family: FontAwesome;
        content: "\f067";
    }

    .faq-title {
        margin-bottom: 5px;
        margin-top: 30px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .account-box {
            margin: 35px auto;
        }
    }
</style>